import { Link } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";

const PUB_IMG = "https://images.pexels.com/photos/35004395/pexels-photo-35004395.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function FishersCrossPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="article-wrap" data-testid="fishers-cross-page">
      <div className="article-hero" style={{ backgroundImage: `url(${PUB_IMG})` }}>
        <div className="article-hero-overlay" />
        <div className="article-hero-content">
          <p className="article-back-hero"><Link to="/" data-testid="fishers-back-link">&larr; Back to Castlefreke</Link></p>
          <div className="article-hero-meta">
            <span>Est. c. 1890</span>
            <span>Fisher&rsquo;s Cross, Ardfield</span>
          </div>
          <h1 className="article-hero-title" data-testid="fishers-title">O&rsquo;Donovan&rsquo;s Bar<br />at Fisher&rsquo;s Cross</h1>
          <p className="article-hero-author">Five generations. One crossroads. A parish pub.</p>
        </div>
      </div>

      <article className="article-container" data-testid="fishers-body">
        <p className="article-lead">
          O&rsquo;Donovan&rsquo;s bar stands at something of an apex point in West Cork. You reach its Fisher&rsquo;s Cross location by heading from the Clonakilty side, in the parish of Ardfield, a few kilometres past the village. Long Strand is off to its right, Red Strand off to its left. At the crossroads here is O&rsquo;Donovan&rsquo;s &mdash; a family-run pub, five generations deep.
        </p>

        <h2 className="article-h2">A family story</h2>
        <p className="article-p">
          The pub&rsquo;s story begins in the late 19th century, when Dennis&rsquo;s grandfather, born in 1890, came to Ardfield to live with his uncle, an O&rsquo;Sullivan, who first ran the bar. It was passed to Dennis&rsquo;s father in 1925, and eventually came into Dennis&rsquo;s own hands in the mid-1990s.
        </p>
        <p className="article-p">
          &ldquo;I was about 11 when I started working here,&rdquo; Dennis recalls. &ldquo;I&rsquo;m 54 now. I probably took it over around 1995, when I was 25 or 26.&rdquo;
        </p>
        <p className="article-p">
          Today it&rsquo;s Dennis, his wife Marie, and their two sons Mark and Cathal who run the show. Both boys pull pints when needed, and fifteen-year-old Cathal might be the one who takes the reins for the next generation. &ldquo;He has that comradery with people. He enjoys being part of it,&rdquo; Dennis smiles.
        </p>

        <h2 className="article-h2">The heart of the parish</h2>
        <p className="article-p">
          Ask Dennis what role O&rsquo;Donovan&rsquo;s plays in the community and he doesn&rsquo;t hesitate. &ldquo;It&rsquo;s a meeting place. Like the creameries once were. Only for places like this, some people wouldn&rsquo;t meet anyone.&rdquo;
        </p>
        <p className="article-p">
          Where you sit, in a side parlour off the bar, portraits of past generations of the family hang on the wall. Dennis&rsquo;s father and grandfather were men who poured pints for the same local families generations earlier. What was once a small, two-room bar was expanded in 1976 by Dennis&rsquo;s father. Since then, smaller additions have been made, including covered outdoor space that is often packed, even in the rain.
        </p>

        <h2 className="article-h2">Music, food &amp; fresh air</h2>
        <p className="article-p">
          Music has long played a central role in the pub, thanks to Breda Cooney, a local woman who has run a trad session every Thursday night for four years. &ldquo;It&rsquo;s one of the best things that ever happened here,&rdquo; Dennis says. &ldquo;Between six and twenty musicians some nights, most local, and it brings people in from everywhere and anywhere.&rdquo;
        </p>
        <p className="article-p">
          Summer weekends bring music too, while outside the front door a mobile pizza van provides customers with nibbles. &ldquo;He brings his own crowd,&rdquo; Dennis says, &ldquo;and it all combines together. Drink, music, food, and fresh air. It seems to be working.&rdquo;
        </p>
        <p className="article-p">
          During the pandemic, Dennis teamed up with a local caterer to run a takeaway pizza service from the pub&rsquo;s old kitchen. &ldquo;He made them, we cooked them,&rdquo; Dennis recalls. &ldquo;The first three weeks, we sold thousands. We were out of business, he was out of business, so we made it work.&rdquo;
        </p>

        <h2 className="article-h2">The changing world of West Cork pubs</h2>
        <p className="article-p">
          Around the time Dennis took over, West Cork&rsquo;s pub scene looked very different. There were more public houses open across the region, and they had a steadier flow of midweek customers. &ldquo;There were older people in here every day, that&rsquo;s all gone now,&rdquo; he says. &ldquo;Habits have changed. But, thank God, the social side of it hasn&rsquo;t. People still come out to meet each other, and that&rsquo;s the important part.&rdquo;
        </p>
        <p className="article-p">
          Yet Dennis sees younger people returning, especially since covid. &ldquo;After covid, when we reopened, it was unbelievable. People weren&rsquo;t on their phones. They were just talking to each other. It showed how important the social side of a pub really is.&rdquo;
        </p>
        <p className="article-p">
          O&rsquo;Donovan&rsquo;s has also seen more continental visitors in recent years &mdash; families with camper vans who veer off the traditional tourist trail looking to experience the real West Cork. &ldquo;Before, you wouldn&rsquo;t see too many foreigners here,&rdquo; he says. &ldquo;Now you&rsquo;d see French, Dutch... They&rsquo;re spreading out more.&rdquo;
        </p>

        <h2 className="article-h2">A simple formula</h2>
        <p className="article-p">
          What works at O&rsquo;Donovan&rsquo;s today is a simple formula: fair-priced pints, a bit of food, regular music, and the wild Atlantic nearby.
        </p>
        <p className="article-p">
          &ldquo;That combination is what keeps people coming,&rdquo; Dennis says. &ldquo;And as long as it works, I&rsquo;m happy to leave it that way.&rdquo;
        </p>
        <p className="article-p" style={{ fontSize: "0.8rem", color: "#7a7770", marginTop: "2rem", fontStyle: "italic" }}>
          Adapted from &ldquo;The Village Pubs of Cork&rdquo; series by Noel Sweeney, Echo Live.
        </p>
      </article>

      {/* Details */}
      <div className="castle-timeline-wrap">
        <div className="castle-timeline" data-testid="fishers-details">
          <h2 className="article-h2" style={{ textAlign: "center", marginBottom: "3rem" }}>Visiting</h2>
          <div className="timeline-item">
            <span className="timeline-year">Where</span>
            <span className="timeline-event">Fisher&rsquo;s Cross, Ardfield, near Clonakilty, Co. Cork. At the crossroads between Long Strand and Red Strand.</span>
          </div>
          <div className="timeline-item">
            <span className="timeline-year">Music</span>
            <span className="timeline-event">Traditional session every Thursday night. Live music on summer weekends.</span>
          </div>
          <div className="timeline-item">
            <span className="timeline-year">Food</span>
            <span className="timeline-event">Pizza van outside on busy nights. No kitchen, but food is never far away.</span>
          </div>
          <div className="timeline-item">
            <span className="timeline-year">Family</span>
            <span className="timeline-event">Dennis &amp; Marie O&rsquo;Donovan, with sons Mark and Cathal. Five generations at the same crossroads.</span>
          </div>
          <div className="timeline-item">
            <span className="timeline-year">Online</span>
            <span className="timeline-event"><a href="https://www.facebook.com/fisherscrossbar/" target="_blank" rel="noopener noreferrer" style={{ color: "#2d3b2d" }}>Facebook: Fisher&rsquo;s Cross Bar</a></span>
          </div>
        </div>
      </div>

      <div className="article-footer">
        <Link to="/" className="article-footer-link" data-testid="fishers-footer-back">&larr; Back to Castlefreke &amp; Long Strand</Link>
      </div>
    </div>
  );
}
